// slices/attendanceAnalyticsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunks
export const fetchTopPerformers = createAsyncThunk(
  'attendanceAnalytics/fetchTopPerformers',
  async ({ month, year }, { rejectWithValue }) => {
    try {
      const response = await axios.get('/api/admin/attendance-analytics/top-performers', {
        params: { month, year }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch top performers');
    }
  }
);

export const fetchEmployeeOfMonth = createAsyncThunk(
  'attendanceAnalytics/fetchEmployeeOfMonth',
  async ({ month, year }, { rejectWithValue }) => {
    try {
      const response = await axios.get('/api/admin/attendance-analytics/employee-of-month', {
        params: { month, year }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch employee of month');
    }
  }
);

const initialState = {
  topPerformers: [],
  employeeOfMonth: null,
  analytics: null,
  history: [],
  loading: false,
  analyticsLoading: false,
  error: null,
  hasWinner: false
};

const attendanceAnalyticsSlice = createSlice({
  name: 'attendanceAnalytics',
  initialState,
  reducers: {
    clearAnalyticsError: (state) => {
      state.error = null;
    },
    resetAnalytics: (state) => {
      state.topPerformers = [];
      state.employeeOfMonth = null;
      state.analytics = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch Top Performers
      .addCase(fetchTopPerformers.pending, (state) => {
        state.analyticsLoading = true;
        state.error = null;
      })
      .addCase(fetchTopPerformers.fulfilled, (state, action) => {
        state.analyticsLoading = false;
        state.topPerformers = action.payload.topPerformers || [];
      })
      .addCase(fetchTopPerformers.rejected, (state, action) => {
        state.analyticsLoading = false;
        state.error = action.payload;
      })
      
      // Fetch Employee of Month
      .addCase(fetchEmployeeOfMonth.pending, (state) => {
        state.analyticsLoading = true;
        state.error = null;
      })
      .addCase(fetchEmployeeOfMonth.fulfilled, (state, action) => {
        state.analyticsLoading = false;
        state.employeeOfMonth = action.payload.employeeOfMonth;
        state.hasWinner = action.payload.hasWinner;
      })
      .addCase(fetchEmployeeOfMonth.rejected, (state, action) => {
        state.analyticsLoading = false;
        state.error = action.payload;
      });
  }
});

export const { clearAnalyticsError, resetAnalytics } = attendanceAnalyticsSlice.actions;
export default attendanceAnalyticsSlice.reducer;